import { generateURL } from 'utils/helpers';

const booking = {
  history: () => {
    const url = generateURL('/bookings');

    return fetch(url).then((response) => {
      const data = response.json();
      const message =
        data.message || `Network response was not ok, code ${response.status}.`;

      return response.ok ? data : Promise.reject(new Error(message));
    });
  },
  promoCode: (code) => {
    const url = generateURL('/booking/promo_code');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        promo_code: code,
      }),
    }).then((response) => {
      if (response.status !== 200) {
        const message = `Promo code ${code} is invalid or doesn’t match conditions`;

        return Promise.reject(Error(message));
      }
      return response.json();
    });
  },
  relatedProducts: ({ type, bookingId, limit }) => {
    let url;

    if (type === 'relatedProducts') {
      url = generateURL('/booking/related_products', {
        limit,
      });
    }

    if (type === 'interestedProducts') {
      url = generateURL('/booking/interested_products', {
        booking_id: bookingId,
        limit,
      });
    }

    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
  documents: (id) => {
    const url = generateURL(`/booking/${id}/documents`);

    return fetch(url, {
      method: 'GET',
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to fetch documents'));
      }
      return response.json();
    });
  },
  generateDocuments: (id) => {
    const url = generateURL(`/booking/${id}/documents`);

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to generate documents'));
      }
      return response.json();
    });
  },
  update: (params) => {
    const url = generateURL('/booking/update');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to update booking'));
      }
      return response.json();
    });
  },
  complete: () => {
    const url = generateURL('/booking/complete');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to complete booking'));
      }
      return response.json();
    });
  },
  updateBookingWithNestedAttributes: (params) => {
    const url = generateURL('/booking/update_with_nested_attributes');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to update booking'));
      }
      return response.json();
    });
  },
  touch: (bookingId) => {
    const params = bookingId ? { booking_id: bookingId } : null;
    const url = generateURL('/booking/touch', params);

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to touch booking'));
      }
      return response.json();
    });
  },
  discard: () => {
    const url = generateURL('/booking/discard');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to discard booking'));
      }
      return response.json();
    });
  },
  current: () => {
    const url = generateURL('/booking/current');

    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to fetch current booking'));
      }
      return response.json();
    });
  },
  calculateQuote: (bookingId, data) => {
    const url = generateURL(`/booking/${bookingId}/calculate_quote`);

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to fetch quote'));
      }
      return response.json();
    });
  },
  deleteFerry: () => {
    const url = generateURL(`/booking/ferry`);

    return fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to delete ferry'));
      }
      return response.json();
    });
  },
};

export default booking;
